
$(function(){
	var original_content = $('ul.picks').html();
	
	$('form[name="article_picks_form"]').submit(function(e) {
		e.preventDefault();
		$.ajax({data:$('form[name="article_picks_form"]').serialize(),success:function(data){
			if(data.status == 'ok'){
				form_submit_response('form[name="article_picks_form"]','success',data.user_msg,true);
				load_picks(data);
			}
			else if(data.status == 'error')
				form_submit_response('form[name="article_picks_form"]','error', data.error);
			else
				form_submit_response('form[name="article_picks_form"]','error', 'An unknown error occurred. Please try again later');
		}});	
	});
	
	$('button.reset').click(function(){
		$('ul.picks').html(original_content);	
	});
	
	$(document).on('change','.article_pick select', function(){
		var aid = $(this).val();
		var $article_pick = $(this).parent();
		var fid = 0;
		var location = $(this).attr('id');

		$('.article_pick select[id!="'+location+'"] option[value="'+aid+'"][value!=""]').attr('disabled','disabled');
		
		$.ajax({data:{module:'news',action:'get-news',filter:aid+'-0',gobal:1,active_for:1,offset:1},success:function(data){
			var cover = (data['num_results'] > 0? data['result'][0]['media'].small_image:'');
			$article_pick.css('background', '#1b1b1b url(' + cover + ') 50% 50% no-repeat');
		}});
	});

});